/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Check: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.8455 3.35881C15.1996 3.68764 15.2201 4.24128 14.8913 4.5954L6.76626 13.3454C6.58739 13.538 6.33139 13.64 6.06905 13.6232C5.80671 13.6064 5.56584 13.4725 5.41305 13.2586L2.28805 8.88359C2.00717 8.49035 2.09825 7.94387 2.49148 7.66299C2.88472 7.3821 3.4312 7.47318 3.71208 7.86642L6.21368 11.3687L13.6089 3.40461C13.9377 3.05049 14.4913 3.02998 14.8455 3.35881Z'
      fill='currentColor'
    />
  </React.Fragment>
)
